const SERVER_SCOPE_DIMS = ['department', 'location', 'city', 'country', 'state', 'company', 'user', 'tenancy'];

const norm = (v) => (v == null ? undefined : Array.isArray(v) ? (v.length ? v : undefined) : [v]);

export function toServerScope(scope) {
    const s = scope || {};
    const out = {};
    for (const dim of SERVER_SCOPE_DIMS) {
        const v = norm(s[dim]);
        if (v) out[dim] = v;
    }
    return Object.keys(out).length ? out : undefined;
}

export function userScopeIsEmails(scope) {
    const users = norm(scope?.user);
    return !users || users.every((v) => String(v).includes('@'));
}

export function selectsEveryOption(options, selected) {
    const offered = options || [];
    const picked = new Set((selected || []).map((v) => String(v)));
    return offered.length > 1 && picked.size === offered.length && offered.every((o) => picked.has(String(o.value)));
}

export function hasTenancyScope(scope) {
    return !!norm(scope?.tenancy);
}

export function serverRowsOrNull(rows, scope) {
    if (!Array.isArray(rows)) return null;
    return rows.length || hasTenancyScope(scope) ? rows : null;
}
